import { Component, OnInit } from '@angular/core';
import { TechnicalserviceService } from '../../services/technicalservice.service';
import { TechnicalserviceCompanyService } from '../../../configuration/services/technicalservice-company.service';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
import { Observable } from 'rxjs/Observable';
declare let alasql;

@Component({
  selector: 'app-list-technicalservice',
  templateUrl: './list-technicalservice.component.html',
  styleUrls: ['./list-technicalservice.component.css'],
  providers:[TechnicalserviceService,TechnicalserviceCompanyService]
})
export class ListTechnicalserviceComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  technicalservices: any = [];  
  technicalserviceCompanies: any = [];

  filters:any = {
    number:{contains: ""},
    product: {contains: ""},
    nif: {contains: ""},
    name: {contains: ""},
    surname: {contains: ""},
    status: "Todos",
    id:{contains: ""},
    enter_by:{contains: ""}
  };
  fromEnterDate:any;
  untilEnterDate:any;
  fromDeliveryDate:any;
  untilDeliveryDate:any;
  role:number = 3;
  exportParams:any ={};
  showExportButton:boolean = true;
  onlyWithInvoice: boolean = false;
  technicalServiceStatuses:any = [
    'Todos',
    'Sin asignar',
    'Sin revisar',
    'Presupuesto aceptado',
    'Pte. de colocar piezas',
    'En proceso',
    'Pte. de aceptar presupuesto',
    'Pte. de llegada de piezas',
    'Finalizado',
    'Pte. de entregar a más con berto',
    'Pte. de recoger por el cliente',
    'Retirado por el cliente'
  ];

  constructor(private technicalserviceService: TechnicalserviceService, private technicalserviceCompanyService:TechnicalserviceCompanyService) { }

  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
      if (location.href.split('?')[1]){
        this.filters = JSON.parse(localStorage.getItem('technicalservice-filter'));   
        this.getTechnicalServices();
        this.getTechnicalserviceCompanies();
      }else{
        this.getTechnicalServices();
        this.getTechnicalserviceCompanies();
      }
    }catch(e){
      this.getTechnicalServices();
      this.getTechnicalserviceCompanies();
    }
  }

  getTechnicalserviceCompanies(){
    this.technicalserviceCompanyService.query({}).subscribe((technicalserviceCompanies)=>{
      this.technicalserviceCompanies = technicalserviceCompanies;
      this.technicalserviceCompanies.unshift({id:null, name:"No filtrar"});
      if (this.filters.technicalserviceCompany === undefined){
        this.filters.technicalserviceCompany = null;
      }
    });
  }

  getTechnicalServices(){
    localStorage.setItem('technicalservice-filter',JSON.stringify(this.filters));
    location.href = location.href.split('?')[0]+"?filters=true";
    if (this.filters.status == "Todos"){
        delete this.filters.status;
    }
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'status_order ASC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (params.where.date && (params.where.date.contains == null || params.where.date.contains == "")){
        delete params.where.date;
    }
    if (params.where.delivery_date_tsc && (params.where.delivery_date_tsc.contains || params.where.delivery_date_tsc.contains == "")){
        delete params.where.delivery_date_tsc;
    }
    if (this.fromEnterDate && moment(this.fromEnterDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.fromEnterDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilEnterDate && moment(this.untilEnterDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.untilEnterDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    if (this.fromDeliveryDate && moment(this.fromDeliveryDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.delivery_date_tsc = params.where.delivery_date_tsc? params.where.delivery_date_tsc:{};
      params.where.delivery_date_tsc[">="] = moment(this.fromDeliveryDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDeliveryDate && moment(this.untilDeliveryDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.delivery_date_tsc = params.where.delivery_date_tsc? params.where.delivery_date_tsc:{};
      params.where.delivery_date_tsc["<="] = moment(this.untilDeliveryDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    if (this.filters.technicalserviceCompany == null){
      delete params.where.technicalserviceCompany; 
    }
    if (this.onlyWithInvoice){
      params.where.invoice = {};
      params.where.invoice["!"] = null;
    }
    this.exportParams = params;
    this.technicalserviceService.query(params)
               .subscribe((technicalservices) => {
                  this.technicalserviceService.count({})
                  .subscribe((count) => {
                    this.totalItems = count.count;
                  });
                  this.technicalservices = technicalservices;
                });
  }

  exportTechnicalServiceToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };    
    let report = []   
    if (!this.onlyWithInvoice){      
        report = [
            {
                field1:"Entrada por",
                field2:"Fecha de entrada",
                field3:"Fecha de entrega al técnico",
                field4:"Nº S.T.",
                field5:"Cliente",
                field6:"Descripción",
                field7:"Anomalia",
                field8:"Técnico Asociado",
                field9:"Técnico información",
                field10:"Estado",
                
            }
        ]
    } else if (this.onlyWithInvoice){
        report = [
            {
                field1:"Nº S.T.",
                field2:"Fecha de Factura",
                field3:"Nº de Factura",
                field4:"Cliente",
                field5:"Nif",
                field6:"Concepto",
                field7:"Base Imponible",
                field8:"IGIC",
                field9:"Total",
                field10:"Método de pago",
                
            }
        ]
    }
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableTechnicalServiceRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100;

      console.log(this.exportParams)
        observableTechnicalServiceRequest.push(this.technicalserviceService.query(this.exportParams));
      }
      Observable.forkJoin(observableTechnicalServiceRequest)
          .subscribe(data => {
            let p:any = data;
            let technicalServices = p.flat(); 

            technicalServices.forEach(technicalservice =>{
                    var row = {};

                    if (!this.onlyWithInvoice){  
                        row = {
                            field1:technicalservice.enter_by?technicalservice.enter_by:"",
                            field2:technicalservice.date?moment(technicalservice.date).format("DD-MM-YYYY"):"",
                            field3:technicalservice.delivery_date_tsc?moment(technicalservice.delivery_date_tsc).format("DD-MM-YYYY"):"",
                            field4:technicalservice.id?technicalservice.id:"",
                            field5:technicalservice.person?technicalservice.person.nif +" - "+technicalservice.person.name+" "+technicalservice.person.surname:"",
                            field6:technicalservice.product?technicalservice.product:"",
                            field7:technicalservice.problems?technicalservice.problems:'',
                            field8:technicalservice.technicalserviceCompany?technicalservice.technicalserviceCompany.name+" - "+technicalservice.technicalserviceCompany.repairman:'',
                            field9:technicalservice.technicalserviceCompany?technicalservice.technicalserviceCompany.telephone+" - "+technicalservice.technicalserviceCompany.address:'',
                            field10:technicalservice.status?technicalservice.status:'',
                        }
                    }else if (this.onlyWithInvoice){
                        row = {
                            field1:technicalservice.id?technicalservice.id:"",
                            field2:technicalservice.invoice?moment(technicalservice.invoice.date).format("DD-MM-YYYY"):"",
                            field3:technicalservice.invoice?technicalservice.invoice.number:"",
                            field4:technicalservice.invoice?technicalservice.invoice.customer_name:"",
                            field5:technicalservice.invoice?technicalservice.invoice.customer_nif:"",
                            field6:technicalservice.problems?technicalservice.problems:"",
                            field7:technicalservice.invoice?(technicalservice.invoice.total_amount - technicalservice.invoice.tax_amount):'',
                            field8:technicalservice.invoice?technicalservice.invoice.tax+"% - "+technicalservice.invoice.tax_amount+"€":'',
                            field9:technicalservice.invoice?technicalservice.invoice.total_amount+"€":'',
                            field10:technicalservice.method_of_payment?technicalservice.method_of_payment:'',
                        }
                    }
                    report.push(row);
                });
                var mystyle = {   
                    headers:true,       
                    columns:    
                        [{columnid:'field1',width:100,title: ''},   
                        {columnid:'field2',width:100,title: ''},
                        {columnid:'field3',width:100,title: 'LISTADO DE SERVICIOS TÉCNICOS'},
                        {columnid:'field4',width:100,title: ''},
                        {columnid:'field5',width:100,title: ''},
                        {columnid:'field6',width:100,title: ''},
                        {columnid:'field7',width:100,title: ''},
                        {columnid:'field8',width:100,title: ''},
                        {columnid:'field9',width:200,title: ''},
                        {columnid:'field10',width:100,title: ''},
                        
                        ],
                    /*header*/
                  
                    column: {  
                        style:{
                            Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",  
                                WrapText:1
                                
                            },
                            Font:{
                                Bold:"1",
                                Color:"#000000",
                                Size:10
                            },
                            
                            Interior:{
                                Color:"#7CEECE",
                                Pattern:"Solid"
                            }
                        }},
                  cells: {    
                        0:{
                            0:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid",
                                        },
                                Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",
                                  WrapText: 1,
                                    },  
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                                },                        
                                }  
                            },
                            1:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                            },  
                                Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },            
                                    }
                            },
                            2:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        }, 
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            }                
                                    }
                                },
                            3:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },            
                                      
                                    }
                                },
                            4:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },
                            5:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                }, 
                            6:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                             
                                }
                                }, 
                                7:{style:{
                                    Interior:{ 
                                        Color:"#95a5a6",
                                        Pattern:"Solid"
                                                },
                                    Alignment:{
                                        Horizontal: 'Center', 
                                        Vertical: 'Center',
                                        WrapText: 1, 
                                    },
                                    Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },                             
                                    }
                                    }, 
                                8:{style:{
                                    Interior:{ 
                                        Color:"#95a5a6",
                                        Pattern:"Solid"
                                                },
                                    Alignment:{
                                        Horizontal: 'Center', 
                                        Vertical: 'Center',
                                        WrapText: 1, 
                                    },
                                    Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },                             
                                    }
                                    }, 
                                9:{style:{
                                    Interior:{ 
                                        Color:"#95a5a6",
                                        Pattern:"Solid"
                                                },
                                    Alignment:{
                                        Horizontal: 'Center', 
                                        Vertical: 'Center',
                                        WrapText: 1, 
                                    },
                                    Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },                             
                                    }
                                    },
                        }   
                  },
            };
            this.showExportButton = true;
            alasql.promise('SELECT * INTO XLSXML("ServiciosTecnicos_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
            .then(function(data){
                console.log('Data saved');
            }).catch(function(err){
                console.log('Error:', err);
            });
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/technicalservice/components/list-technicalservice/list-technicalservice.component.ts